import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Translate} from 'react-redux-i18n';
import Modal from 'react-modal';
import {Icon, AbstractFormComponent, validators} from 'front-onceforall-core';
import TextField from '@material-ui/core/TextField';

import * as snackbarsActions from '../../../../actions/snackbars';
import enrollmentService from '../../../../services/enrollment';
import CancelConfirmButtons from '../../../buttons/form/CancelConfirmButtons';

const MAX_LENGTH_ACCESS_CODE = 100;

export class AccessCodeModalForm extends AbstractFormComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      errorMessage: null
    };
  }

  getFormData() {
    return {
      accessCode: ''
    };
  }

  getFormValidators() {
    return {
      accessCode: validators.requiredValidator
    };
  }

  handleChangeCallback() {
    this.setState({errorMessage: null});
  }

  handleSubmitCallback() {
    enrollmentService.general.addSubcontractorViaAccessCode(this.props.organisation.organisationId, this.state.formData.accessCode)
      .then(() => {
        this.props.actions.addSuccess(<Translate value="subcontractor.accessCode.success"/>);
        this.props.history.push('/subcontractors');
        this.props.onClose();
      })
      .catch(error => {
        error.response.json().then(() => {
          if (error.response.status === 404) {
            this.setState({
              errorMessage: 'subcontractor.accessCode.modal.errorNotFound',
              submitted: false,
              submitting: false
            });
          } else if (error.response.status === 400) {
            this.setState({
              errorMessage: 'user.invite.self',
              submitted: false,
              submitting: false
            });
          } else {
            this.props.actions.addError(<Translate value="error.generic"/>);
            this.props.onClose();
          }
        });
      });
  }

  render() {
    return (
      <Modal
        defaultStyles={{
          overlay: {
            backgroundColor: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 13
          },
          content: {
            backgroundColor: '#fff',
            borderRadius: 4,
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
            outline: 0,
            padding: 20,
            position: 'relative',
            maxWidth: 800,
            textAlign: 'center'
          }
        }}
        isOpen
        onRequestClose={this.props.onClose}
        ariaHideApp={false}
        shouldCloseOnOverlayClick
      >
        <div>
          <form onSubmit={this.handleSubmit}>
            <h2><Translate value="subcontractor.accessCode.modal.title"/></h2>
            <p
              data-id="content"
              className="py-3"
            >
              <Translate value="subcontractor.accessCode.modal.message"/>
            </p>
            {this.state.errorMessage &&
              <div className="box flex-container mb-5 rejected error">
                <span className="flex-shrink-0">
                  <Icon
                    icon="cross"
                    size={20}
                  />
                </span>
                <Translate
                  data-id="error-message"
                  value={this.state.errorMessage}
                />
              </div>
            }
            <TextField
              id="accessCode"
              name="accessCode"
              label={this.getFieldLabel('subcontractor.accessCode.modal.title', true)}
              error={Boolean(this.isOnError('accessCode'))}
              helperText={this.helperText('accessCode')}
              value={this.state.formData.accessCode}
              onChange={this.handleChange('accessCode')}
              autoFocus
              inputProps={{
                maxLength: MAX_LENGTH_ACCESS_CODE
              }}
            />
            <CancelConfirmButtons
              onClose={this.props.onClose}
              submitting={this.state.submitting}
            />
          </form>
        </div>
      </Modal>
    );
  }
}

AccessCodeModalForm.propTypes = {
  history: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  organisation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccessCodeModalForm));
